module.exports = __webpack_public_path__ + "static/media/LogoWhite.05241a95.png";